module.exports = __webpack_public_path__ + "img/suone_5.9eece311.jpg";